<template>
  <div class="mt-5 body-1">
    <span v-if="isFob">
      <v-icon>
        mdi-truck-outline
      </v-icon>
      Frete FOB
    </span>
    <span class="green--text" v-else>
      <v-icon color="success">mdi-truck-outline</v-icon>
      <template v-if="frete.valorTaxaEntrega">
        {{ frete.valorTaxaEntrega | currency }} de frete
      </template>
      <template v-else>
        Frete Grátis
      </template>
    </span>
    <div v-if="frete.ofertaFreteGratis" class="green--text">
      <small>
        Esta empresa oferece frete grátis a partir de
        {{ frete.taxaMinimaEntrega | currency }}
      </small>
    </div>
    <div>
      <small>
        {{ prazoPrefix }} {{ frete.prazoEmbarque | pluralize(['dia útil', 'dias úteis']) }}
      </small>
    </div>
  </div>
</template>

<script>
import { TipoFrete } from 'px-business-components';

export default {
  props: {
    frete: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFob() {
      return this.frete && this.frete.tipoFrete === TipoFrete.keys.FOB.key;
    },
    prazoPrefix() {
      if (this.isFob) {
        return 'Embarque em';
      }
      return 'Entrega em';
    },
  },
};
</script>
